import axios from "axios";
import EventEmitter from "events";
import env from "../../utils/env.config";
import { getCookie, removeCookie, setCookie } from "../CookieHelper";
import { COOKIE_ENUM } from "../enums";
import { getVisitorToken } from "./APICalls";

axios.defaults.baseURL = env.baseUrl;

export const interceptorEmitter = new EventEmitter();

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (typeof window !== "undefined") {
      if (config && config.headers) {
        config.headers.version = env.apiV2;
        const token: string = getCookie(COOKIE_ENUM.TOKEN) as string;
        if (!config.headers.Authorization && token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      // if franchise id not found emit an event to call link table to user, app context is listening to this event
      if (config && config.data && config.data.franchiseId === -1) {
        interceptorEmitter.emit("linkTableToUser");
      }
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const unauthorisedPages = ["/404"];

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response && response.status !== 200) {
      // router.push("/404");
      // location('/404')
    }

    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (
      error.response?.status === 401 &&
      !unauthorisedPages.includes(window.location.pathname) &&
      error.response?.config?.baseURL === axios.defaults.baseURL
    ) {
      removeCookie(COOKIE_ENUM.TOKEN);
      getVisitorToken().then((res) => {
        const resToken = res.data.token;
        setCookie(COOKIE_ENUM.TOKEN, resToken);
      });
    } else {
      return Promise.reject(error);
    }
  }
);
